import * as React from "react";

import { cn } from "@/lib/utils";

/** Native select in the look of {@link Input}; enough for short lists. */
function Select({ className, ...props }: React.ComponentProps<"select">) {
  return (
    <select
      data-slot="select"
      className={cn(
        "h-9 rounded-md border border-input bg-transparent px-2 text-sm shadow-xs outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50 dark:bg-background",
        className,
      )}
      {...props}
    />
  );
}

export { Select };
